import { render, staticRenderFns } from "./HubSection.vue?vue&type=template&id=3e7f8db4&scoped=true"
import script from "./HubSection.vue?vue&type=script&lang=js"
export * from "./HubSection.vue?vue&type=script&lang=js"
import style0 from "./HubSection.vue?vue&type=style&index=0&id=3e7f8db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f8db4",
  null
  
)

export default component.exports